import assign from 'object-assign';
import uuid from 'uuid/v4';
import moment from 'moment';
import {
  SET_FIRST_NAME,
  SET_LAST_NAME,
  SET_EMAIL_ADDRESS,
  SET_MOBILE_PHONE,
  SET_DATE_OF_BIRTH,
  SET_GROUP_ID,
  SET_GENDER,
  SET_MARITAL_STATUS,
  SET_GUEST,
  SET_FIRST_NAME_ERRORS,
  SET_LAST_NAME_ERRORS,
  SET_EMAIL_ADDRESS_ERRORS,
  SET_MOBILE_PHONE_ERRORS,
  SET_DATE_OF_BIRTH_ERRORS,
  SET_GROUP_ID_ERRORS,
  SET_GENDER_ERRORS,
  SET_MARITAL_STATUS_ERRORS,
  SET_GUEST_ERRORS,
  ADD_FAMILY_MEMBER,
  REMOVE_FAMILY_MEMBER,
  SET_ERRORS
} from '../actionTypes/familyMembers';


export const addFamilyMember = () => ({
  type: ADD_FAMILY_MEMBER,
  id: uuid()
});

export const removeFamilyMember = (id) => ({
  type: REMOVE_FAMILY_MEMBER,
  id: id
});


/*** Value setters ***/

export const setFirstName = (id, value) => ({
  type: SET_FIRST_NAME,
  id, value
});

export const setLastName = (id, value) => ({
  type: SET_LAST_NAME,
  id, value
});

export const setDateOfBirth = (id, value) => ({
  type: SET_DATE_OF_BIRTH,
  value: moment.isMoment(value) ? value.format('YYYY-MM-DD') : value,
  id
});

export const setGroup = (id, value) => ({
  type: SET_GROUP_ID,
  id, value
});

export const setGender = (id, value) => ({
  type: SET_GENDER,
  id, value
});

export const setGuest = (id, value) => ({
  type: SET_GUEST,
  id, value
});


/*** Error setters ***/

export const setFirstNameErrors = (id, errors) => ({
  type: SET_FIRST_NAME_ERRORS,
  id, errors
});

export const setLastNameErrors = (id, errors) => ({
  type: SET_LAST_NAME_ERRORS,
  id, errors
});

export const setDateOfBirthErrors = (id, errors) => ({
  type: SET_DATE_OF_BIRTH_ERRORS,
  id, errors
});

export const setGroupErrors = (id, errors) => ({
  type: SET_GROUP_ID_ERRORS,
  id, errors
});

export const setGenderErrors = (id, errors) => ({
  type: SET_GENDER_ERRORS,
  id, errors
});

export const setGuestErrors = (id, errors) => ({
  type: SET_GUEST_ERRORS,
  id, errors
});

export const setErrors = (id, errors) => ({
  type: SET_ERRORS,
  id, errors
});


// WEBPACK FOOTER //
// ./src/actions/familyMembers.js